import React from "react";

const CurrencyCalculation = () => {
  return (
    <div className="dg__calculation__area bg__color--1 poss--relative section-padding--xlg">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="dg__calculation">
              <h2>Calculate Your Crypto Staking Rewards</h2>
              <p>
                Use our calculator to estimate your staking rewards for MATIC, BNB, USDC, LINK, and ETH. Staking on MetaNetwork is simple and transparent, allowing you to make informed decisions.
              </p>
              <div className="calculate__box">
                <p>Staking Rewards Calculator</p>
                <input
                  className="crypto-converter"
                  type="text"
                  placeholder={1}
                  data-current-rate="9205.68"
                />
                <span>=</span>
                <input
                  className="crypto-converter-output"
                  type="text"
                  placeholder="Estimated Rewards"
                />
                <div className="dg__select__option">
                  <select>
                    <option>MATIC</option>
                    <option>BNB</option>
                    <option>USDC</option>
                    <option>LINK</option>
                    <option>ETH</option>
                  </select>
                  <select className="space--left">
                    <option>US Dollar (USD)</option>
                    <option>Euro (EUR)</option>
                    <option>Pound (GBP)</option>
                    <option>Japanese Yen (JPY)</option>
                    <option>Canadian Dollar (CAD)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="shape--1 col-lg-6">
            <img
              src={process.env.PUBLIC_URL + "/images/about/bitcoin.jpg"}
              alt="MetaNetwork"
              style={{ maxWidth: '30rem', marginLeft: '7rem' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyCalculation;
